import { render, staticRenderFns } from "./ScreenshotList.vue?vue&type=template&id=a6a95866&scoped=true&"
import script from "./ScreenshotList.vue?vue&type=script&lang=js&"
export * from "./ScreenshotList.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotList.vue?vue&type=style&index=0&id=a6a95866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a95866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
